export enum EligibilityConditionCode {
	INTERVENTION_CAP = "1",
	PROTOCOL_ADHERENCE = "3",
	PI_TO_RECURRENCE_CAP = "5",
	RECURRENCE_TO_SI_CAP = "6",
	ADMINISTRATION_ADHERENCE_RATE = "7",
	TEST_THRESHOLD = "8",
	NUMBER_OF_PRESCRIPTIONS = "9",
	CYCLE_ADHERENCE = "10",
	CLAIM_COVERAGE = "11",
}

export enum EligibilityStatus {
	UNCERTAIN = "uncertain",
	ELIGIBLE = "eligible",
	INELIGIBLE = "ineligible",
}

export enum EligibilityResponseType {
	UNCERTAIN = "uncertain",
}

export enum EncapsulatedFeatureKeys {
	Reporting = "reporting",
	CrossAgreementReporting = "cross-agreement-reporting",
	Quests = "quests",
	SimulatorBusinessCase = "simulator-business-case",
	DocumentAdjustment = "document-adjustment",
	DocumentSummary = "document-summary",
	ConfigurablePdfReport = "configurable-pdf-report",
	RebateReconciliationReport = "rebate-reconciliation-report",
	//Features with custom behavior and storing type
	Breakdown = "Breakdown",
	ProductInput = "ProductInput",
	SimulatorModelValidity = "SimulatorModelValidity",
	YearlyThreshold = "YearlyThreshold",
	WasteReporting = "WasteReporting",
	PublicAgreement = "PublicAgreement",
	LibraryGPT = "LibraryGPT",
	NavlinPrices = "NavlinPrices",
	EmailEncryption = "EmailEncryption",
	AutomatedRunFrequency = "AutomatedRunFrequency",
	AgreementRunTriggers = "AgreementRunTriggers",
	DocumentSftpSaving = "DocumentSftpSaving",
	AutoIssuance = "AutoIssuance",
	Sso = "Sso",
	AutomatedReviewReminders = "AutomatedReviewReminders",
	SmartMipReview = "smart-mip-review",
	PdfReportAttachment = "pdf-report-attachment",
	CommentAttachments = "comment-attachments",
}

export enum Modules {
	LL = "6",
}

export enum SuspensionReason {
	INACTIVITY = "INACTIVITY",
	THERAPY_DISCONTINUATION = "THERAPY DISCONTINUATION",
}

export enum Role {
	Administrator = "Administrator",
	User = "User",
	SU = "SuperUser",
}

export enum DateValidationReference {
	CURRENT_DAY = "CURRENT_DAY",
	CURRENT_MONTH = "CURRENT_MONTH",
	CURRENT_YEAR = "CURRENT_YEAR",
}

export enum AttributeDependencyScope {
	ENTITY = "ENTITY",
	CASE = "CASE",
}

export enum AttributeDependencyOperator {
	EQUAL = "EQUAL",
	LESS_THEN = "LESS_THEN",
	LESS_THEN_OR_EQUAL = "LESS_THEN_OR_EQUAL",
	GREATHER_THEN = "GREATHER_THEN",
	GREATHER_THEN_OR_EQUAL = "GREATHER_THEN_OR_EQUAL",
	ALLOWED_LIST = "ALLOWED_LISTS",
}

export enum RevocationReasonOptions {
	STORNO = "storno",
	STORNO_VOR_LEA = "stornovorlea",
	STORNO_ABGERECHNET = "stornoabegerechnet",
}
